export default __webpack_public_path__ + "static/media/couple@2x.1f7f649c.png";